import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { AuthLayout } from './auth/components/AuthLayout';

import { LoginScreen } from './auth/LoginScreen';
import { Layout } from './components/Layout';

import { ScreenArtists } from './screens/artists/ScreenArtists';
import { ScreenCalendar } from './screens/ScreenCalendar';
import { ScreenEditRequest } from './screens/request/ScreenEditRequest';
import { ScreenRequests } from './screens/request/ScreenRequest';
import { ScreenCreateArtist } from './screens/artists/ScreenCreateArtist';
import { ScreenEditArtist } from './screens/artists/ScreenEditArtist';

import { AccountLayout } from './screens/account/AccountLayout';
import { ScreenAccountPassword } from './screens/account/ScreenAccountPassword';

import { ScreenAddRequest } from './screens/request/ScreenAddRequest';
import { AuthProvider } from './screens/AuthProvider';
import { ExampleScreen } from './screens/ExampleScreen';
import { SettingsScreen } from './screens/settings/SettingsScreen';

export const BookerRoutes = () => {
	return (
		<Routes>
			<Route
				path="booker"
				element={
					<AuthProvider>
						<Layout>
							<Outlet />
						</Layout>
					</AuthProvider>
				}
			>
				<Route index element={<ScreenRequests />} />

				<Route path="requests" element={<Outlet />}>
					<Route index element={<ScreenRequests />} />
					<Route path="create/" element={<ScreenAddRequest />} />
					<Route path=":id/" element={<ScreenEditRequest />} />
				</Route>

				<Route path="artists" element={<Outlet />}>
					<Route index element={<ScreenArtists />} />
					<Route path="create/" element={<ScreenCreateArtist />} />
					<Route path=":id/" element={<ScreenEditArtist />} />
				</Route>

				<Route path="settings" element={<Outlet />}>
					<Route index element={<SettingsScreen />} />
				</Route>

				<Route path="calendar" element={<ScreenCalendar />} />

				<Route path="example" element={<ExampleScreen />} />

				<Route
					path="account"
					element={
						<AccountLayout>
							<Outlet />
						</AccountLayout>
					}
				>
					<Route index element={<ScreenAccountPassword />} />

					{/* <Route index element={<ScreenAccount />} />
					<Route path="password" element={<ScreenAccountPassword />} />
					<Route path="organization" element={<ScreenAccountOrganization />} /> */}
				</Route>
			</Route>
			<Route path="/booker/auth" element={<Outlet />}>
				<Route
					index
					element={
						<AuthLayout>
							<LoginScreen />
						</AuthLayout>
					}
				/>
			</Route>
		</Routes>
	);
};
